import type { IntermediateOrderSearchResult } from "../redistribution/models/IntermediateOrderSearchResult.ts";
import type { IntermediateOrderSkuRow } from "../redistribution/models/IntermediateOrderSkuRow.ts";
import {
  searchIntermediateOrders as searchIntermediateOrdersApi,
  searchIntermediateOrdersWithDiagnostics,
} from "./apiClient.ts";

/**
 * Searches for a Bulk Order or Intermediate PO by identifier, including
 * view-only Bulk Order allocations and diagnostics when no Intermediate PO
 * rows exist.
 */
export async function searchIntermediateOrderResultByIdentifier(
  query: string,
  includeFirstCosts = false
): Promise<IntermediateOrderSearchResult> {
  return searchIntermediateOrdersWithDiagnostics(
    query.trim(),
    includeFirstCosts
  );
}

/**
 * Searches for a Bulk Order or Intermediate PO by identifier. Shared by the
 * header search input (AppHeader.vue) and the "Bulk Order Lookup" search
 * panel tab (OpenPurchaseOrdersSearchPanel.vue).
 */
export async function searchIntermediateOrdersByIdentifier(
  query: string,
  includeFirstCosts = false
): Promise<IntermediateOrderSkuRow[]> {
  return searchIntermediateOrdersApi(query.trim(), includeFirstCosts);
}
